import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerListaSerieService = async (values) => {
    try {
        return await instance.Backend.post("/Indicador/ListaSerie", values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { ObtenerListaSerieService };